import gql from 'graphql-tag';

export const AB_TEST_QUERY = gql`
    query {
        abTests {
            id
            name
        }
    }
`;

export type ABTest = {
    id: string;
    name: string;
};

export type AbTestQueryResponse = {
    abTests: ABTest[] | null;
};
